import React from 'react';

function Logo(props) {

    return (
        <div className="logo">Sounds</div>
    );
}

export default Logo;